import { render, staticRenderFns } from "./CaseLoad.vue?vue&type=template&id=f5f73486&scoped=true&"
import script from "./CaseLoad.vue?vue&type=script&lang=js&"
export * from "./CaseLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f73486",
  null
  
)

export default component.exports